// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import DataVaxiomSysOrganizationsLocationSelect from './data'

export default function DataVaxiomSysOrganizationsLocationSelectFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/DataVaxiomSysOrganizationsLocationSelect">
      <DataVaxiomSysOrganizationsLocationSelect {...props}>
        {children}
      </DataVaxiomSysOrganizationsLocationSelect>
    </Flow>
  )
}
